export default __webpack_public_path__ + "static/media/Backspace_Menz.aff3ca62.png";